import Flickity from "flickity";

document.addEventListener("alpine:init", () => {
    Alpine.data("heroInteractive", (autoplay, vidsrc) => ({
        videoType: "upload",
        videoPlaying: false,
        video: null,
        vid: null,
        videoPlayer: null,
        vidSrc: vidsrc,
        isMoble: true,
        slider: null,
        sliderContainer: null,
        currentIndex: 0,
        isAnimating: false,
        sliderEnd: false,
        visible: false,
        autoplay: autoplay || 5,
        init() {
            this.video =
                this.$root.querySelector("video.media-video") ||
                this.$root.querySelector("iframe.media-video");

            this.videoPlayer = this.$root.querySelector(
                "#Hero__Interactive-video source"
            );

            this.vid = this.$root.querySelector("#Hero__Interactive-video");

            this.videoPlaying = true;

            // Assign the embed video type if needed
            if (this.video && this.video.classList.contains("video-embed")) {
                this.videoType = "embed";
            }

            this.sliderContainer = this.$refs.slider;
            const slides =
                this.sliderContainer.querySelectorAll(".ticker-slide");

            this.slider = new Flickity(this.sliderContainer, {
                autoPlay: this.autoplay * 1000,
                cellAlign: "center",
                contain: true,
                wrapAround: false,
                prevNextButtons: false,
                pageDots: false,
                fade: true,
                draggable: true,
                on: {
                    settle: () => {
                        this.currentIndex = this.slider.selectedIndex;
                    },
                    ready: () => {
                        window.dispatchEvent(new Event("resize"));
                        this.sliderResize();
                    },
                    change: (index) => this.changeSlide(index),
                },
            });

            this.currentIndex = this.slider.selectedIndex;

            this.slider.on("change", () => {
                this.updateTabIndexes(slides);
                this.updateSliderEnd();
            });

            pegasus.onResizeFinished(() => {
                this.sliderResize();

                this.isMobile = window.outerWidth <= 960;

                if (!this.isMobile && this.vidSrc) {
                    this.videoPlayer.src = this.vidSrc;
                    this.vid.load();
                }
            }, true);

            this.updateTabIndexes(slides);
            this.updateSliderEnd();
        },
        /**
         * togglePlayState
         *
         * Description: Toggles the play state of the video when the button is pressed.
         *
         */
        togglePlayState() {
            if (
                typeof this.$refs.videoPlaceholder != "undefined" &&
                this.$refs.videoPlaceholder
            ) {
                this.$refs.videoPlaceholder.classList.add("hidden");
            }

            // Standard HTML5 videos can simply use the play() and pause() methods.
            if (this.videoType === "upload") {
                if (this.videoPlaying) {
                    this.video.pause();
                    this.videoPlaying = false;
                } else {
                    this.video.play();
                    this.videoPlaying = true;
                }

                return;
            }

            // Embed videos need to update the autoplay parameter in the URL.
            if (this.videoType === "embed") {
                const currentSrc = this.video.src;

                const currentSrcArray = currentSrc.split("&");

                let newSrc = "";

                currentSrcArray.forEach((part) => {
                    if (part.includes("autoplay=")) {
                        if (this.videoPlaying) {
                            part = "autoplay=0";
                            this.videoPlaying = false;
                        } else {
                            part = "autoplay=1";
                            this.videoPlaying = true;
                        }
                    }
                    newSrc += part + "&";
                });

                this.video.src = newSrc;
            }
        },
        sliderResize() {
            const flickitySliders = document.querySelectorAll(
                ".ticker-slider .flickity-slider"
            );

            this.sliderFullWidth = 0;

            flickitySliders.forEach((slider) => {
                const slides = slider.querySelectorAll(".ticker-slide");
                let height = 0;

                slides.forEach((slide) => {
                    slide.style.height = "";
                    this.sliderFullWidth += slide.offsetWidth;
                    if (slide.offsetHeight > height) {
                        height = slide.offsetHeight;
                    }
                });

                slides.forEach((slide) => {
                    slide.style.height = height + "px";
                });

                slider.style.height = "";
                slider.style.height = height + "px";
            });
        },

        previousSlide() {
            if (window.innerWidth >= 768) {
                this.isAnimating = true;
            }
            this.slider.previous();
            setTimeout(() => {
                this.isAnimating = false;
            }, 700);
        },
        nextSlide() {
            if (window.innerWidth >= 768) {
                this.isAnimating = true;
            }
            this.slider.next();
            setTimeout(() => {
                this.isAnimating = false;
            }, 700);
        },
        changeSlide(index) {
            if (window.innerWidth >= 768) {
                this.isAnimating = true;
            }
            this.currentIndex = index;
            setTimeout(() => {
                this.isAnimating = false;
            }, 700);
        },
        /**
         * updateTabIndexes
         *
         * Description: Updates the tabindexes of the slides this is required for accessibility.
         * Inactive slides shouldn't be accessible via the keyboard.
         *
         * @param {} slides
         */
        updateTabIndexes(slides) {
            slides.forEach((slide) => {
                const slideElements = slide.querySelectorAll("a, button");

                slideElements.forEach((element) => {
                    if (slide.classList.contains("is-selected")) {
                        element.removeAttribute("tabindex");
                    } else {
                        element.setAttribute("tabindex", "-1");
                    }
                });
            });
        },

        /**
         * updateSliderEnd
         *
         * Description: Updates sliderEnd property based on whether the slider is at the end or not.
         */
        updateSliderEnd() {
            const selectedIndex = this.slider.selectedIndex;
            const slideCount = this.slider.slides.length;
            this.sliderEnd = selectedIndex === slideCount - 1;
        },
    }));
});
